export enum ConnectionStatus {
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
  UNKNOWN = 'UNKNOWN',
  PROCESSING = 'PROCESSING',
  CREATING = 'CREATING',
}
